import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Log Value Step
 *
 * Accepts any input value, logs it with a configurable message template,
 * and passes it through. The template supports `{value}` interpolation.
 *
 * Useful for debugging and testing workflow execution.
 */
export const logValueStep = defineStepConfig({
  type: "log_value",
  name: "Log Value",
  description:
    "Logs an input value with a configurable message template and passes it through",
  category: "Utility",

  inputSchema: z.object({
    value: z.any().optional().describe("The value to log"),
  }),

  outputSchema: z.object({
    value: z.any().describe("The input value passed through"),
    message: z.string().describe("The formatted log message"),
  }),

  configSchema: z.object({
    template: z
      .string()
      .prefault("Received value: {value}")
      .describe(
        "Message template. Use {value} to interpolate the input value.",
      ),
  }),

  emits: [] as const,
});
